/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
function nospaces(event) {
  var k = event ? event.which : window.event.keyCode;
  if (k == 32) return false;
}

function getVal(el) {
  return (el && el.value ? el.value : '').toLowerCase().trim();
}

function togglePersonalisation() {

  var select = document.querySelector('select[name*="options[Personalise]"]');
  if (!select) return;

  var isYes = (getVal(select) === 'yes');

  // INPUTS
  var firstName = document.getElementById('first-name');
  var lastName = document.getElementById('surname-name');
  var school = document.getElementById('dschool-name');

  // LABELS (THIS WAS MISSING)
  var firstLabel = document.getElementById('first-name-label');
  var lastLabel = document.querySelector('label[for="surname-name"]');
  var schoolLabel = document.querySelector('label[for="dschool-name"]');

  // AGREEMENT
  var checkbox = document.getElementById('personalisation-agreement');
  var agreeLabel = document.getElementById('agree-label');

  function set(el, show) {
    if (!el) return;
    el.style.display = show ? '' : 'none';
  }

  function setRequired(el, required) {
    if (!el) return;
    required ? el.setAttribute('required', 'required')
             : el.removeAttribute('required');
  }

  // TOGGLE ALL FIELDS
  set(firstName, isYes);
  set(lastName, isYes);
  set(school, isYes);

  set(firstLabel, isYes);
  set(lastLabel, isYes);
  set(schoolLabel, isYes);

  set(checkbox, isYes);
  set(agreeLabel, isYes);

  // REQUIRED LOGIC
  setRequired(firstName, isYes);
  setRequired(lastName, isYes);
  setRequired(checkbox, isYes);
}

// Run on variant change
document.addEventListener('change', function (e) {
  if (e.target && e.target.name && e.target.name.indexOf('options[Personalise]') > -1) {
    togglePersonalisation();
  }
});

// Run on page load
document.addEventListener('DOMContentLoaded', function () {
  togglePersonalisation();
});